import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpEventType, HttpHeaders} from '@angular/common/http';
import {ConfigService, ErrorsService, SensorHistoryLoader, Sensor, Route} from 'shared';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {decode} from '@msgpack/msgpack';


@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class SensorService {

  constructor(private http: HttpClient, private config: ConfigService, private errors: ErrorsService) {
  }

  history(loader: SensorHistoryLoader, id: number, from, to: Date, detectChanges: boolean): Observable<SensorHistoryLoader> {
    loader.startLoading();
    return this.http.post(this.config.apiVerUrl(`/app/sensors/${id}/history`), {from, to, detect_changes: detectChanges}, {
      responseType: 'arraybuffer',
      reportProgress: true,
      observe: 'events',
      headers: new HttpHeaders(
        {'Content-Type': 'application/json'},
      )
    }).pipe(
      map<HttpEvent<ArrayBuffer>, SensorHistoryLoader>((e: HttpEvent<ArrayBuffer>) => {
        if (e.type === HttpEventType.Response) {
          loader.sensor = new Sensor(decode(e.body));
          loader.endLoading();
        } else if (e.type === HttpEventType.DownloadProgress) {
          loader.total = e.total;
          loader.loaded = e.loaded;
          loader.isLoaded = false;
        }
        return loader;
      }),
    );
  }
}
